import { memo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { CHANNEL_BROWSER } from 'shared-modules/constants';
import { TAB_INDIVIDUAL_NOTICE, TEXT_NO_MESSAGES } from 'shared-modules/constants/message';
import { getMessagesRequest } from 'shared-modules/redux/actions/messageActions';
import { Spin } from '../../../components';
import { Card } from '../Card';
import { Accordion } from '../Accordion';
import styles from './contents.module.scss';

export const Contents = memo(() => {
  const dispatch = useDispatch();
  const { currentTab, loading, messages, defaultOpenedMessageId } = useSelector((state) => state.message);

  useEffect(() => {
    const isIndividual = currentTab === TAB_INDIVIDUAL_NOTICE;
    dispatch(getMessagesRequest({ isIndividual, channel: CHANNEL_BROWSER }));
  }, [dispatch, currentTab]);

  if (loading) {
    return (
      <div className={styles.loader}>
        <Spin />
      </div>
    );
  }

  if (!messages?.length) {
    return <div className={styles.noMessage}>{TEXT_NO_MESSAGES}</div>;
  }

  return currentTab === TAB_INDIVIDUAL_NOTICE ? (
    <Accordion messages={messages} defaultOpenedMessageId={defaultOpenedMessageId} />
  ) : (
    <div className={styles.container}>
      {messages.map((message) => (
        <Card key={message.messageId} message={message} />
      ))}
    </div>
  );
});
